import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Complexity } from "../../entities/complexity";

@Injectable()
export class ComplexityRepo extends Repository<Complexity>{
    constructor(private dataSource: DataSource) {
        super(Complexity, dataSource.createEntityManager());
    }
}